import { DataDownloadMessages } from '../types';

export const dataDownloadCA: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'Estudiar a l’estranger',
  'app.datadownload.checkbox.additional_demographics_info': 'Dades demogràfiques addicionals',
  'app.datadownload.checkbox.remove_anonymous_user': 'Eliminar usuaris anònims',
}
